import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listSplitSupplyContracts } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListSplitSupplyContractsRequestSchema,
  type ListSplitSupplyContractsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 分割供給契約 一覧取得 hook。
 */
export function useListSplitSupplyContracts(): UseQueryResult<
  ListSplitSupplyContractsResponse,
  ConnectError
> {
  return useQuery(
    listSplitSupplyContracts,
    create(ListSplitSupplyContractsRequestSchema),
    // 本番の既定は throwOnError: true。 一覧の失敗は表のエラー行で案内するので伝播させない
    { throwOnError: false },
  )
}
